import React, { memo } from 'react';

import styles from './styles/ToggleButton.module.css';

const ToggleButton = ({ isEnabled, onChange, size = 'medium', disabled = false }) => {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={isEnabled}
            className={`${styles.toggle} ${styles[size]} ${isEnabled ? styles.enabled : ''}`}
            onClick={onChange}
            disabled={disabled}
        >
            <span className={styles.thumb} />
        </button>
    );
};

export default memo(ToggleButton);
